import { clientApi } from "@/utils/api";
import { TCreateCaseRequestDto } from "@/api/services/main/case/dtos/create-case.dto";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { TGetCaseRequestDto, TGetCaseResDto } from "@/api/services/main/case/dtos/get-case.dto";
import { TGetCaseCountResDto } from "@/api/services/main/case/dtos/get-case-count.dto";
import { useMemo } from "react";

export const fetchCaseListApi = async () => {
  const { data } = await clientApi.get("/cases");
  return data;
};

export const createCase = async (caseDataRequest: TCreateCaseRequestDto) => {
  const { data } = await clientApi.post("/cases", caseDataRequest);
  return data;
};

export const fetchCaseInfo = async (id: number | string, params: TGetCaseRequestDto): Promise<TGetCaseResDto> => {
  const { data } = await clientApi.get(`/cases/${id}`, { params });
  return data;
};

export const useCaseInfo = (id: number | string, params: TGetCaseRequestDto) => {
  const { caseId } = useParams();

  const fetchId = id ?? caseId;

  const isValidId = useMemo(() => {
    if (!fetchId) return false;
    const idNumber = Number(fetchId);
    return !isNaN(idNumber) && Number.isInteger(idNumber) && idNumber > 0;
  }, [fetchId]);

  return useQuery({
    queryKey: [QUERY_KEYS.CASE.FETCH_LIST, fetchId],
    queryFn: async () => {
      return fetchId ? await fetchCaseInfo(fetchId, params) : undefined;
    },
    enabled: isValidId,
  });
};

export const fetchCaseCountApi = async (): Promise<TGetCaseCountResDto> => {
  const { data } = await clientApi.get<TGetCaseCountResDto>("/cases/count");
  return data;
};

export const useCaseCount = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CASE.FETCH_COUNT],
    queryFn: async () => {
      return await fetchCaseCountApi();
    },
  });
};
